import { NetworkStatus } from '@cbridge-utils/network';
import { ICoverageServerStore } from './coverageServer.interface';

export const coverageServerInitialState: ICoverageServerStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
};
